var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#384047",
    d: "M1.648 12.299c0 .496.37.9.824.9 5.85 0 5.53-.043 5.784.105l4.949 2.87-.27-1.941c-.076-.544.31-1.035.815-1.035h2.626c.454 0 .824-.403.824-.9V3.642c0-.496-.37-.9-.824-.9H2.472c-.454 0-.824.404-.824.9zm8.857 4.347l-2.84-1.649H2.471C1.109 14.997 0 13.787 0 12.3V3.64C0 2.153 1.109.943 2.472.943h13.904c1.363 0 2.472 1.21 2.472 2.698V12.3c0 1.488-1.11 2.698-2.472 2.698h-1.668l.371 2.677c.076.544-.311 1.034-.814 1.034-.274 0-.24-.02-2.111-1.106zm3.554-10.25c.795 0 1.441.706 1.441 1.574 0 .868-.646 1.574-1.441 1.574s-1.442-.706-1.442-1.574c0-.868.646-1.574 1.442-1.574zm-4.635 0c.795 0 1.442.706 1.442 1.574 0 .868-.647 1.574-1.442 1.574-.795 0-1.442-.706-1.442-1.574 0-.868.647-1.574 1.442-1.574zm-4.635 0c.795 0 1.442.706 1.442 1.574 0 .868-.647 1.574-1.442 1.574-.795 0-1.442-.706-1.442-1.574 0-.868.647-1.574 1.442-1.574z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialog);
export default __webpack_public_path__ + "static/media/dialog.33836f9f16ee0c4247c517a16ba03742.svg";
export { ForwardRef as ReactComponent };